
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAndroidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.779 10.813c.844.501.897 1.679.158 2.264l-.158.11-14.352 8.51a1.38 1.38 0 0 1-2.083-1.187V3.49a1.38 1.38 0 0 1 2.083-1.186l14.352 8.51ZM4.355 2.434l13 13M16.385 8.534 5.017 21.218",
  stroke: "#000",
  strokeWidth: 1.6
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n<path d=\"M20.7788 10.8135C21.6233 11.3142 21.6759 12.4918 20.937 13.0771L20.7788 13.1865L6.42725 21.6963C5.50804 22.2413 4.34424 21.5784 4.34424 20.5098L4.34424 3.49023C4.34424 2.42158 5.50804 1.75866 6.42725 2.30371L20.7788 10.8135Z\" stroke=\"black\" stroke-width=\"1.6\"/>\r\n<line x1=\"4.35524\" y1=\"2.43431\" x2=\"17.3552\" y2=\"15.4343\" stroke=\"black\" stroke-width=\"1.6\"/>\r\n<line x1=\"16.3853\" y1=\"8.53394\" x2=\"5.01695\" y2=\"21.2182\" stroke=\"black\" stroke-width=\"1.6\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/android-icon.d560496fb384eecdc9ab39fdceacb19b.svg"),
        {
          React: SvgAndroidIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      